import React, { Component } from "react";
import "./loader.css";

export default class Loader extends Component {
  render() {
    return (
      <div className="loader">
        <div className="loading">
          <span>T</span>
          <span>H</span>
          <span>E</span>
          <span>O</span>
          <span>R</span>
          <span>Y</span>
          <span>D</span>
          <span>E</span>
          <span>V</span>
        </div>
      </div>
    );
  }
}
